import { render, staticRenderFns } from "./EditBestellung.vue?vue&type=template&id=bc21b2c6&scoped=true&"
import script from "./EditBestellung.vue?vue&type=script&lang=js&"
export * from "./EditBestellung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc21b2c6",
  null
  
)

export default component.exports